import React, { useEffect, useRef } from "react";
import { RichText } from "prismic-reactjs";

const formatDate = (date) => {
    let split = date.split("-");
    return `${split[1]}-${split[2]}-${split[0]}`;
};

export default function NewsItem({ item }) {
  const imgRef = useRef(null);
  const summaryRef = useRef(null);

  useEffect(() => {
    const img = imgRef.current;
    const summary = summaryRef.current;
    if (!img || !summary) return;

    const isSummaryEmpty = () => {
      const text = summary.textContent || "";
      return text.trim().length === 0;
    };

    const updateSummaryHeight = () => {
      if (isSummaryEmpty()) {
        const h = img.clientHeight || img.naturalHeight || 0;
        summary.style.minHeight = h ? `${h+20}px` : "0";
      } else {
        summary.style.minHeight = "0";
      }
    };

    if (img.complete) {
      updateSummaryHeight();
    } else {
      img.addEventListener("load", updateSummaryHeight);
      return () => img.removeEventListener("load", updateSummaryHeight);
    }
  }, [item.data.summary]);

  return (
    <div className="news-item">
      <div className="date">{formatDate(item.data.publication_date)}</div>
      <div className="title">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={item.data.url.url}
        >
          {item.data.link_title}
        </a>
      </div>

      <img
        ref={imgRef}
        src={item.data.image.url}
        alt={item.data.link_title}
      />

      <div ref={summaryRef} className="summary">
        <RichText render={item.data.summary} />
      </div>

      <div className="link">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={item.data.url.url}
        >
          Read More
        </a>
      </div>
    </div>
  );
}
